import { createNav, bindNav } from "./components/Nav.js";
import { createFooter } from "./sections/Footer.js";
import { createContactSection } from "./sections/Contact.js";
import { createProductHeroSection } from "./sections/product/ProductHero.js";
import { createProductShowcaseSection } from "./sections/product/ProductShowcase.js";
import { getProductPage, productRoute } from "../config/productContent.js";

export function mountProductPage(root) {
  const pageContent = getProductPage();

  const canvasLayer = document.createElement("div");
  canvasLayer.className = "canvas-layer";
  canvasLayer.innerHTML = `<canvas id="canvas" aria-hidden="true"></canvas>`;

  const contentLayer = document.createElement("div");
  contentLayer.className = "content-layer content-layer--product";

  const nav = createNav();

  contentLayer.append(
    nav,
    createProductHeroSection(),
    createProductShowcaseSection(),
    createContactSection(),
    createFooter()
  );

  root.append(canvasLayer, contentLayer);

  const updateNavActive = bindNav(nav, {
    page: "product",
    sectionMap: {
      hero: productRoute("hero"),
      showcase: productRoute("showcase"),
      ...Object.fromEntries(
        (pageContent.showcase?.services || []).map((service) => [
          service.id,
          productRoute(service.id),
        ])
      ),
      contact: productRoute("contact"),
    },
  });

  return {
    canvas: canvasLayer.querySelector("#canvas"),
    updateNavActive,
    documentTitle: pageContent.documentTitle,
    sections: {
      hero: contentLayer.querySelector("#hero"),
      showcase: contentLayer.querySelector("#showcase"),
      contact: contentLayer.querySelector("#contact"),
    },
  };
}
